import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import checkView from 'vue-check-view'
Vue.use(checkView)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
